import React, { Fragment, useContext, useEffect, useState } from "react";

// Provider
import {
  AppContext,
  SET_PAGE_STATE,
  SocketCommand,
  socketManager,
} from "../../../components/AppProvider";

// Utils

// UI
import { AlertLayer } from "../../../components/UI/Dialog";
import { Container, openLayerFn } from "../../Layout";

import { NativeAction } from "../../../modules/utils/HandleWs";
import { userHabit } from "../../../modules/utils/UserHabit";
import { ToastMessageOmron } from "../../common/Layer/ToastMesssage";
import { putBodyData } from "./Main";
import Step1 from "./OmronTutorial/Step1";
import useTitle from "../../../modules/hooks/useTitle";

export default props => {
  const { userinfo, cfg, phonecfg, deviceCfg, pageState, dispatch } =
    useContext(AppContext);
  useTitle("마이페이지_악세사리_OMRON");

  const [isConnected, setIsConnected] = useState(
    deviceCfg.deviceTypes[0].devices[props.match.params.test].isConnected
  );
  const [isConnecting, setIsConnecting] = useState(false);

  const [pageIdx, setPageIdx] = useState(1);

  const settingState = (param1, param2) => {
    // setIsConnected(param1);
    setIsConnecting(param2);

    socketManager(SocketCommand.GET_BT_STATUS, undefined, putBodyData());
  };

  // 다이얼로그 [[
  const [dialog, setDialog] = useState({
    title: "",
    msg: "",
  });

  const handleDialog = (title, msg) => {
    setDialog({
      title: title,
      msg: msg,
    });

    openLayerFn($(".alert-layer"));
  };

  const handleAlertCB = () => {};
  // 다이얼로그 ]]

  // 단말기 연동 api 호출
  const handleConnect = e => {
    try {
      settingState(false, true);
      $(".bt-slide").slick("slickGoTo", 7);
      socketManager(SocketCommand.BP170B_REGISTER, settingState, {
        type: 0,
        modelName: "Omron",
      });
    } catch (e) {
      handleDialog("", "기기연결은 단말기에서만 동작됩니다.");
      return;
    }
  };

  // 단말기 연동 api 호출
  const handleDisConnect = e => {
    try {
      socketManager(SocketCommand.BP170B_REMOVE, settingState, {
        type: 0,
        modelName: "Omron",
      });
      settingState(false, true);
    } catch (e) {
      handleDialog("", "기기연결해제는 단말기에서만 동작됩니다.");
      return;
    }
  };

  useEffect(() => {
    userHabit(phonecfg, "ST112");
    NativeAction(phonecfg, "statusColor", "#A5AEE4");
  }, [phonecfg.version]);

  const minusPageIdx = () => {
    if (pageIdx > 1) {
      setPageIdx(pageIdx - 1);
    }
  };

  const plusPageIdx = () => {
    if (pageIdx < 7) {
      setPageIdx(pageIdx + 1);
    }
  };

  useEffect(() => {
    // dispatch({
    //   type: SET_PAGE_STATE,
    //   data: {
    //     type: "reload",
    //     state: 0,
    //   },
    // });
    socketManager(SocketCommand.GET_BT_STATUS, undefined, putBodyData());
  }, []);

  useEffect(() => {
    if (pageState.reload === 1) {
      dispatch({
        type: SET_PAGE_STATE,
        data: {
          type: "reload",
          state: 0,
        },
      });

      // 연결해제 후 위조건의 isConnected의 상태는 항상 false로 LOOP현상
      if (isConnecting) {
        // socketManager(SocketCommand.GET_BT_STATUS, undefined, putBodyData());
      }
    }

    setIsConnected(
      deviceCfg.deviceTypes[0].devices[props.match.params.test].isConnected
    );
  }, [pageState.reload]);

  // useEffect(() => {
  //   setIsConnecting(false);
  // }, [deviceCfg.deviceTypes[0].devices[props.match.params.test].isConnected]);

  useEffect(() => {
    if (pageState.reload === 2) {
      setIsConnecting(false);
    }
  }, [pageState.reload]);

  return (
    <Fragment>
      <Container
        Title={"기기연결(혈압)"}
        dark={"dark"}
        isMain={false}
        goToUrl={"/mp/settings/accessory"}>
        <div className="contents">
          <div className="sub-contents">
            <Step1
              pageIdx={pageIdx}
              minusPageIdx={minusPageIdx}
              plusPageIdx={plusPageIdx}
              setPageIdx={setPageIdx}
            />
          </div>
        </div>

        <div className="fix-area">
          <div className="under-fix-btnarea">
            {isConnected === false ? (
              isConnecting === false ? (
                <a className="btn-connect" onClick={e => handleConnect(e)}>
                  <i></i>연결
                </a>
              ) : (
                <a className="btn-connect-ing">
                  <i></i>연결중
                </a>
              )
            ) : (
              <a className="btn-unconnect" onClick={e => handleDisConnect(e)}>
                <i></i>연결 해제
              </a>
            )}
          </div>
        </div>
      </Container>

      <AlertLayer
        title={dialog.title}
        msg={dialog.msg}
        handleConfirmCB={handleAlertCB}
      />
      <ToastMessageOmron msgIdx={pageIdx} />
    </Fragment>
  );
};

// 단말기 연동 api 호출
/*
 *   device: 0:혈압
 */
export const handleMeasure = (phonecfg, device, deviceName, handleDialog) => {
  try {
    console.log("phonecfg.phoneOS====" + phonecfg.phoneOS);
    if (phonecfg.phoneOS === "ANDROID") {
      window.java.measureDevice(device, deviceName);
    } else {
      webkit.messageHandlers.removeDevice.postMessage(
        device.toString() + ":" + deviceName
      );
    }
  } catch (e) {
    handleDialog("", "단말기에서만 동작됩니다.");
    return;
  }
};
